import React, { useCallback, useState } from 'react'
import Modal from 'components/Modal'
import Textarea from 'components/Textarea'

import Form from 'pages/shared/Form'

import { scrubText } from 'helpers/inputCleaners'

type Props = {
  note: string
  isSaving?: boolean
  onSaveCallback: (updatedNote: string) => Promise<void>
  closeCallback: () => void
}

const EditNote = ({ note, isSaving = false, closeCallback, onSaveCallback }: Props) => {
  const [updatedNote, setUpdatedNote] = useState(note)

  const onCancelClick = useCallback(() => {
    closeCallback()
  }, [closeCallback])

  const onSaveClick = useCallback(async (updatedNote) => {
    await onSaveCallback(updatedNote)
  }, [onSaveCallback])

  return (
    <Modal title="Edit Notes" isDisplayed closeCallback={onCancelClick} variant="sm">
      <Form isSaving={isSaving} onSaveCallback={async () => await onSaveClick(updatedNote)} onCancelCallback={onCancelClick} >
        <Textarea isRequired={false} label="Notes" rows={5} value={updatedNote ?? ''} onChange={event => setUpdatedNote(scrubText(event.target.value, true))} />
      </Form>
    </Modal>
  )
}

export default EditNote
